import React from 'react';
import ReactDOM from 'react-dom/client';
// NOTA: BrowserRouter removido - ahora usamos createBrowserRouter en App.js
import './utils/sessionStorage';
import './index.css';
import './styles/scrollbars.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Manejador global de errores de chunks - REHABILITADO Y MEJORADO
// Detecta errores de carga de lazy loading y recarga la página automáticamente UNA VEZ
window.addEventListener('error', (event) => {
  // Detectar errores de carga de chunks (Chrome/Edge/Firefox)
  const isChunkError =
    event.message?.includes('Loading chunk') ||
    event.message?.includes('ChunkLoadError') ||
    (event.filename && event.filename.includes('.chunk.js')) ||
    event.message?.includes('Failed to fetch dynamically imported module');

  if (isChunkError) {
    event.preventDefault();
    console.warn('⚠️ [Auto-Fix] Detectado error de carga de chunk. Intentando recuperar sesión...');

    // Evitar loops infinitos: Solo recargar si no se ha recargado recientemente (últimos 10s)
    const lastReload = parseInt(sessionStorage.getItem('chunk_reload_timestamp') || '0');
    const now = Date.now();

    if (now - lastReload > 10000) {
      sessionStorage.setItem('chunk_reload_timestamp', now.toString());
      window.location.reload();
    } else {
      console.error('❌ [Auto-Fix] Error persistente de chunk detectado. Se detuvo la recarga automática para evitar bucles.');
    }
  }
});

// Manejador para promesas rechazadas (Safari a veces reporta import() fallidos aquí)
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('Loading chunk') ||
    event.reason?.message?.includes('Failed to fetch dynamically imported module')) {

    // Lógica idéntica de prevención de loops
    const lastReload = parseInt(sessionStorage.getItem('chunk_reload_timestamp') || '0');
    const now = Date.now();

    if (now - lastReload > 10000) {
      sessionStorage.setItem('chunk_reload_timestamp', now.toString());
      window.location.reload();
    }
  }
});

console.log('🔧 [System] Monitor de integridad de chunks activo');

const root = ReactDOM.createRoot(document.getElementById('root'));

// React Router ahora se maneja internamente en App.js con createBrowserRouter
root.render(
  // React.StrictMode desactivado temporalmente - causa doble renders
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// 📱 Registrar Service Worker para PWA - TEMPORALMENTE DESACTIVADO PARA DEBUGGING
// serviceWorkerRegistration.register({
//   onSuccess: () => {
//     console.log('✅ [PWA] Contenido cacheado para uso offline');
//   },
//   onUpdate: (registration) => {
//     console.log('🔄 [PWA] Nueva versión disponible');
//     // Opcional: Mostrar notificación al usuario
//     if (window.confirm('Nueva versión disponible. ¿Actualizar ahora?')) {
//       registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
//       window.location.reload();
//     }
//   }
// });

// Desregistrar cualquier Service Worker existente
serviceWorkerRegistration.unregister();

console.log('🔧 [DEBUG] Service Worker desactivado temporalmente para debugging');
